import { makeAutoObservable } from 'mobx';

import { ValidationResponse } from "../DTOs/ValidationResponse";
import { TransactionDTO } from "../DTOs/Payment/TransactionDTO";
import { ajaxController } from "./AjaxController";
import { PaymentResponseDto } from "../DTOs/Payment/StripePaymentResponse";

type TransactionPaymentRequest = {
  transactionId: number
  cardAmount: number
  type: 0 // 0 - order
  courier: number
  serviceType: string
  eori: string
  declaredDelivery: Date
  saturdayDelivery: boolean
  totalDeliveryCost: number
  costWithoutVat: number
  vat: number
  publisherPrice: number
}

export class TransactionAjaxController {
  private _ajaxController = ajaxController;
  private _transactionEndpoint = "stockistTransaction"

  getOrCreateTransaction(stockistId: number) {
    return this._ajaxController.get<TransactionDTO>(`${this._transactionEndpoint}/${stockistId}/NSStockist`,
      {},
      TransactionDTO)
  }

  getTransaction(transactionId: number) {
    return this._ajaxController.get<TransactionDTO>(`${this._transactionEndpoint}/${transactionId}`,
      {},
      TransactionDTO)
  }

  validateOrderCreation(data: TransactionPaymentRequest) {
    return this._ajaxController.post<TransactionPaymentRequest, ValidationResponse>(
      `${this._transactionEndpoint}/createOrder/validate`,
      data,
      ValidationResponse
    )
  }

  createOrder(data: TransactionPaymentRequest): Promise<any> {
    return this._ajaxController.postNoCast<TransactionPaymentRequest, TransactionPaymentRequest>(
      `${this._transactionEndpoint}/createOrder`,
      data
    )
  }

  // new
  getStripePaymentIntent = async (transactionId: number) => {
    return ajaxController.get<PaymentResponseDto>(
      `${this._transactionEndpoint}/stripe/intent/${transactionId}`,
      {},
      PaymentResponseDto
    );
  };

  startPayment = async (paymentIntentId: string) => {
    return ajaxController.getNoCast<null>(
      `${this._transactionEndpoint}/payment/start/${paymentIntentId}`,
      {}
    );
  };

  constructor() {
    makeAutoObservable(this);
  }
}

export const transactionAjaxController = new TransactionAjaxController();